import React from "react";
import {CreateButton} from "react-admin";

type CustomCreateButtonProps = {
  label: string,
}

const CustomCreateButton = (props: CustomCreateButtonProps) => <CreateButton label={props.label} />

export default CustomCreateButton;